// lib
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Transition } from 'react-transition-group'

// styles
import style from '@aytm/app/stats/page/sidebar/specifications/styles/SpecificationsPanel.module.scss'

const RowCollapsable = ({ label, values }) => {
  const [collapsed, setCollapsed] = useState(
    (Array.isArray(values) && 10 < values.length) || (!Array.isArray(values) && 200 < values.length)
  )

  return (
    <div className={style.row}>
      <span className={`${style.column} ${style['column-label']}`}>{label}:</span>
      {(Array.isArray(values) && 10 < values.length) || (!Array.isArray(values) && 200 < values.length) ? (
        <Transition in={!collapsed} timeout={500}>
          {status => (
            <>
              <div
                className={`${style.column} ${style['column-values']} ${style['transition-panel']}${
                  status ? ' ' + style['transition-panel-' + status] : ''
                }`}
                dangerouslySetInnerHTML={{ __html: Array.isArray(values) ? values.join('<br/>') : values }}
              ></div>
              <span className={style['column-toggle']} onClick={() => setCollapsed(!collapsed)}>
                {collapsed ? '+' : '-'}
              </span>
            </>
          )}
        </Transition>
      ) : (
        <div
          className={`${style.column} ${style['column-values']}`}
          dangerouslySetInnerHTML={{ __html: Array.isArray(values) ? values.join('<br/>') : values }}
        ></div>
      )}
    </div>
  )
}

RowCollapsable.propTypes = {
  label: PropTypes.string,
  values: PropTypes.any
}

RowCollapsable.displayName = 'RowCollapsable'

export default RowCollapsable
